import axios from "axios"
import { getCoeficienteAmortizacionAdapter } from "./CoeficienteAmortizacion.adapter"
import { GetAllCoeficientesAmortizacionDtoIPagedEnumerableProps } from "./Schemas/GetAllCoeficientesAmortizacionDtoIPagedEnumerable"

export async function getCoeficienteAmortizacion() {
  const { data } =
    await axios.get<GetAllCoeficientesAmortizacionDtoIPagedEnumerableProps>(
      "/CoeficienteAmortizacion"
    )
  return {
    currentPage: data.currentPage,
    items: data.items?.map((coeficiente) =>
      getCoeficienteAmortizacionAdapter(coeficiente)
    ),
    totalCount: data.totalCount,
  }
}
